import script from "./FailedPayment.vue?vue&type=script&setup=true&lang=js"
export * from "./FailedPayment.vue?vue&type=script&setup=true&lang=js"

import "./FailedPayment.vue?vue&type=style&index=0&id=c7a82e8e&scoped=true&lang=css"

import exportComponent from "/home/forge/hike.marketing/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-c7a82e8e"]])

export default __exports__